import React from "react";
import styled, { css } from "styled-components";

const ButtonStyling = css`
  appearance: none;
  line-height: inherit;
  background: ${props => props.theme.colors.warningRed};
  border-radius: 4px;
  border: 2px solid ${props => props.theme.colors.warningRed};
  color: white;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 10px;
  padding: 10px 30px;
  text-decoration: none;
  transform: translateY(0);
  transition: all 0.3s ease-in-out;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0);
  width: 100%;

  @media (min-width: ${props => props.theme.desktopWidth}) {
    &:not(.span) {
      max-width: 240px;
    }

    &.third {
      max-width: 31%;
      margin-left: 1%;
      margin-right: 1%;
    }

    &.half {
      max-width: 45%;
    }

    &.sideMargin {
      margin-left: 15px;
      margin-right: 15px;
    }

    &.verticalMargin {
      margin-top: 15px;
      margin-bottom: 15px;
    }
  }

  &.wider {
    max-width: 350px;
  }

  &.full_width {
    max-width: 100%;
  }

  &[disabled] {
    background: white;
    border-color: ${props => props.theme.colors.uiGrey};
    box-shadow: none;
    color: ${props => props.theme.colors.uiGrey};
    cursor: default;

    &:hover {
      background-color: white;
    }
  }
`;

const FormStyledButton = styled.button`
  ${ButtonStyling}

  &:hover,
  &:focus {
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.4);
    transform: translateY(-2px);
  }
`;

export const StyledLink = styled.a`
  ${ButtonStyling}

  &:hover,
  &:focus {
    pointer: cursor;
  }
`;

export default ({ className, style, children, onClick, disabled }) => (
  <FormStyledButton
    className={className}
    style={style}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </FormStyledButton>
);
